let numberAttemps = 0
export const retryWaitingFor = (callback, wait = 1000, maxAttemps = 25) => {
  const expression = callback()
  if (expression && numberAttemps <= maxAttemps) {
    setTimeout(() => retryWaitingFor(callback, wait, maxAttemps), wait)
    numberAttemps++
  } else if (numberAttemps >= maxAttemps) {
    console.log(`Deixando de executar function retryWaitingFor() apos ${maxAttemps} tentativas.`)
  }
}
